(function(){
  var root=document.querySelector('.hl');
  if(!root)return;
  var forms=root.querySelectorAll('[data-hl-form]');
  var sTitle=root.querySelector('[data-hl-sticky-title]'),sPrice=root.querySelector('[data-hl-sticky-price]'),sCompare=root.querySelector('[data-hl-sticky-compare]');
  function select(id){
    forms.forEach(function(f){
      f.querySelector('[data-hl-id]').value=id;
      f.querySelectorAll('.hl-bundle').forEach(function(card){
        var input=card.querySelector('input');
        var on=input.value===String(id);
        input.checked=on;
        card.classList.toggle('is-selected',on);
        if(on){
          var p=f.querySelector('[data-hl-price]');if(p)p.textContent=input.dataset.price;
          if(sTitle)sTitle.textContent=input.dataset.title;
          if(sPrice)sPrice.textContent=input.dataset.price;
          if(sCompare)sCompare.textContent=input.dataset.compare;
        }
      });
    });
    try{var u=new URL(location.href);u.searchParams.set('variant',id);history.replaceState(null,'',u)}catch(e){}
  }
  forms.forEach(function(f){
    f.addEventListener('change',function(e){if(e.target&&e.target.type==='radio')select(e.target.value)});
    f.addEventListener('submit',function(){var b=f.querySelector('[data-hl-buy]');if(b){b.setAttribute('aria-busy','true');b.style.opacity='.8'}});
  });
  var slides=root.querySelectorAll('[data-hl-slide]'),thumbs=root.querySelectorAll('[data-hl-thumb]');
  thumbs.forEach(function(t){t.addEventListener('click',function(){
    var i=t.dataset.hlThumb;
    slides.forEach(function(s){s.classList.toggle('is-active',s.dataset.hlSlide===i)});
    thumbs.forEach(function(x){x.classList.toggle('is-active',x===t)});
  })});
  var sticky=root.querySelector('[data-hl-sticky]'),buy=root.querySelector('#hl-buy .hl-btn--buy'),bottom=root.querySelector('.hl-buycard'),ticking=false;
  function upd(){
    ticking=false;
    var vh=window.innerHeight,past=buy.getBoundingClientRect().bottom<0,b=bottom?bottom.getBoundingClientRect():null;
    var inBottom=b?(b.top<vh&&b.bottom>0):false;
    var show=past&&!inBottom;
    sticky.classList.toggle('is-visible',show);
    sticky.setAttribute('aria-hidden',show?'false':'true');
  }
  if(sticky&&buy){
    window.addEventListener('scroll',function(){if(!ticking){ticking=true;requestAnimationFrame(upd)}},{passive:true});
    window.addEventListener('resize',upd);
    upd();
  }
})();
(function(){
  var root=document.querySelector('.hl');if(!root)return;
  var forms=[].slice.call(root.querySelectorAll('[data-hl-form]'));if(!forms.length)return;
  var ON=true,busy=false;
  function money(c){return '$'+(c/100).toFixed(2)}
  function sc(i){var v=i.dataset.subCents;return v?parseInt(v,10):null}
  function seal(f,w){
    var t=f.querySelector('.sealsubs-target-element');if(!t)return null;
    var rs=[].slice.call(t.querySelectorAll('input.sls-option'));if(!rs.length)return null;
    for(var i=0;i<rs.length;i++){
      var one=rs[i].value==='one_time';
      if(w==='sub'&&!one)return rs[i];
      if(w==='one'&&one)return rs[i];
    }
    return null;
  }
  function paint(){
    forms.forEach(function(f){
      var card=f.querySelector('[data-hl-subcard]');if(card)card.classList.toggle('is-on',ON);
      var cb=f.querySelector('[data-hl-subtoggle]');if(cb)cb.checked=ON;
      f.querySelectorAll('.hl-bundle').forEach(function(b){
        var i=b.querySelector('input');if(!i)return;
        var base=parseInt(i.dataset.cents||'0',10),sub=sc(i);
        var now=(ON&&sub!==null&&sub<base)?sub:base;
        var cmp=(ON&&sub!==null&&sub<base)?base:parseInt(i.dataset.compareCents||'0',10);
        var pe=b.querySelector('[data-hl-cardprice]');if(pe)pe.textContent=money(now);
        var ce=b.querySelector('[data-hl-cardcompare]');
        if(ce){if(cmp>now){ce.textContent=money(cmp);ce.hidden=false}else{ce.hidden=true}}
        var n=parseInt(i.dataset.count||'0',10),ue=b.querySelector('[data-hl-unit]');
        if(ue&&n>0)ue.textContent=money(Math.round(now/n))+' per patch';
        if(i.checked){var p=f.querySelector('[data-hl-price]');if(p)p.textContent=money(now)}
      });
    });
    var s=root.querySelector('.hl-bundle.is-selected input')||root.querySelector('.hl-bundle input:checked');
    if(s){
      var b2=parseInt(s.dataset.cents||'0',10),su=sc(s);
      var nw=(ON&&su!==null&&su<b2)?su:b2;
      var sp=root.querySelector('[data-hl-sticky-price]');if(sp)sp.textContent=money(nw);
      var scm=root.querySelector('[data-hl-sticky-compare]');
      if(scm)scm.textContent=money((ON&&su!==null&&su<b2)?b2:parseInt(s.dataset.compareCents||'0',10));
      var t2=root.querySelectorAll('[data-hl-subtitle]');
      if(su!==null&&su<b2){
        var pct=Math.round((b2-su)*100/b2);
        for(var k=0;k<t2.length;k++)t2[k].textContent='Subscribe & Save '+pct+'%';
      }
    }
  }
  function setOn(v){
    if(busy)return;busy=true;ON=!!v;
    forms.forEach(function(f){var r=seal(f,ON?'sub':'one');if(r&&!r.checked)r.click()});
    paint();
    setTimeout(function(){busy=false},60);
  }
  function reveal(){
    var any=false;
    forms.forEach(function(f){
      if(seal(f,'sub')){
        var w=f.querySelector('[data-hl-sub]');if(w)w.classList.add('is-ready');
        var c=f.querySelector('[data-hl-subcard]');if(c)c.hidden=false;
        any=true;
      }
    });
    return any;
  }
  forms.forEach(function(f){
    f.addEventListener('change',function(e){
      var t=e.target;if(!t)return;
      if(t.hasAttribute&&t.hasAttribute('data-hl-subtoggle')){setOn(t.checked);return}
      if(t.type==='radio'&&t.name&&t.name.indexOf('hl-bundle-')===0)setTimeout(paint,0);
    });
  });
  var tries=0;
  (function boot(){
    tries++;
    if(reveal()){
      setOn(true);
      forms.forEach(function(f){
        var t=f.querySelector('.sealsubs-target-element');if(!t||!window.MutationObserver)return;
        var d=null;
        new MutationObserver(function(){
          clearTimeout(d);
          d=setTimeout(function(){if(reveal()&&!busy){var r=seal(f,ON?'sub':'one');if(r&&!r.checked)r.click();paint()}},120);
        }).observe(t,{childList:true,subtree:true});
      });
      return;
    }
    if(tries<80)setTimeout(boot,250);
  })();
})();
(function(){
  var root=document.querySelector('.hl');if(!root)return;
  function inSeal(el){return el&&el.closest&&el.closest('.sealsubs-target-element')}
  var forms=[].slice.call(root.querySelectorAll('[data-hl-form]'));
  forms.forEach(function(f){
    ['change','click','input'].forEach(function(evt){
      f.addEventListener(evt,function(e){if(inSeal(e.target))e.stopPropagation()},true);
    });
  });
  setTimeout(function(){
    if(root.querySelector('.hl-bundle input:checked'))return;
    var first=root.querySelector('.hl-bundle input:not([disabled])');
    if(first){first.checked=true;first.dispatchEvent(new Event('change',{bubbles:true}))}
  },400);
})();
(function(){
  var root=document.querySelector('.hl');if(!root)return;
  var forms=[].slice.call(root.querySelectorAll('[data-hl-form]'));
  function planId(f){
    var s=f.querySelector('select[name="subs_interval"]');
    if(s){
      if(s.value)return s.value;
      var o=s.querySelector('option[value]:not([value=""])');
      if(o)return o.value;
    }
    return '';
  }
  function sync(){
    forms.forEach(function(f){
      var hid=f.querySelector('input[name="selling_plan"]');
      if(!hid){hid=document.createElement('input');hid.type='hidden';hid.name='selling_plan';f.appendChild(hid)}
      var cb=f.querySelector('[data-hl-subtoggle]');
      hid.value=(cb&&cb.checked)?planId(f):'';
    });
  }
  document.addEventListener('change',function(e){
    var t=e.target;
    if(t&&t.hasAttribute&&t.hasAttribute('data-hl-subtoggle'))setTimeout(sync,120);
  },true);
  forms.forEach(function(f){f.addEventListener('submit',sync,true)});
  setTimeout(sync,2500);
})();
